<template>
  <div class="aviso" :class="[`aviso-${type}`, { 'aviso-centered': centered }]" role="status">
    <div class="aviso-icon" aria-hidden="true" v-if="icon">
      <i :class="`fa fa-${icon}`"></i>
    </div>
    <div class="aviso-content">
      <div class="aviso-title">{{ title }}</div>
      <div class="aviso-text"><slot /></div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'Aviso',
    props: {
      title: {
        type: String,
        required: true
      },
      type: {
        type: String,
        default: 'warning',
        validator: value => ['warning', 'success', 'info', 'danger'].includes(value)
      },
      icon: {
        type: String,
        default: 'info'
      },
      centered: {
        type: Boolean,
        default: false
      }
    }
  }
</script>

<style scoped>
  .aviso {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 14px;
    border: 1px solid;
    border-radius: 12px;
  }

  .aviso-icon {
    display: flex;
    flex: 0 0 40px;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    color: #ffffff;
    border-radius: 12px;
  }

  .aviso-content {
    min-width: 0;
  }

  .aviso-title {
    color: #343a40;
    font-weight: 700;
    line-height: 1.2;
  }

  .aviso-text {
    margin-top: 3px;
    font-size: 0.8rem;
    line-height: 1.35;
  }

  .aviso-centered .aviso-content {
    width: 100%;
  }

  .aviso-centered .aviso-title {
    text-align: center;
  }

  .aviso-warning {
    color: #6c5a32;
    background-color: #fff9eb;
    border-color: #f3d17a;
  }

  .aviso-warning .aviso-icon {
    background-color: #f5b51b;
  }

  .aviso-success {
    color: #356450;
    background-color: #f0faf6;
    border-color: #aee5d0;
  }

  .aviso-success .aviso-icon {
    background-color: var(--lecard-success);
  }

  .aviso-info {
    color: #365b70;
    background-color: #f1f8fc;
    border-color: #b8dbea;
  }

  .aviso-info .aviso-icon {
    background-color: #2e86ab;
  }

  .aviso-danger {
    color: #743f45;
    background-color: #fff3f4;
    border-color: #efb8be;
  }

  .aviso-danger .aviso-icon {
    background-color: #dc3545;
  }
</style>
